import React from 'react';
import { CalendarClock, Clock } from 'lucide-react';
import { StatusBadge, DirectionLabel } from './StatusBadge';
import { ExpectedCell, LastEvent, PartyCell, RowTags, TrackingCell } from './ShipmentCells';
import { rowTone } from '../../utils/shipmentsFormat';
import { useRowOpen } from './useRowOpen';

// Mobile layout of the list: one card per shipment, same behaviour as a table row.
const ShipmentCards = ({ rows }) => {
  const openRow = useRowOpen();
  return (
    <ul className="shp-mlist" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {rows.map((row) => (
        <li key={row.id} className={`shp-mcard ${rowTone(row) ? `shp-mcard--${rowTone(row)}` : ''}`} onClick={openRow(row.id)}>
          <div className="shp-mcard__top">
            <StatusBadge status={row.status} />
            <DirectionLabel direction={row.direction} />
          </div>
          <TrackingCell row={row} />
          {row.description && <div className="shp-wrap" dir="auto" style={{ fontSize: 13, color: '#555' }}>{row.description}</div>}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}><RowTags row={row} /></div>
          <div style={{ fontSize: 14 }}><PartyCell row={row} /></div>
          <div className="shp-mcard__meta">
            <span><CalendarClock size={14} aria-hidden="true" /> <span className="shp-sr">Očekáváno: </span><ExpectedCell row={row} /></span>
            <span><Clock size={14} aria-hidden="true" /> <span className="shp-sr">Poslední událost: </span><LastEvent at={row.lastEventAt} /></span>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ShipmentCards;
